module.exports = __webpack_public_path__ + "img/wordsmith.35aac4f6.png";